import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {TheCrypt} from "../TheCrypt";
import {gsap} from "gsap";

export class TheCryptNormalBetPresentation implements FlowStatePresentation {

    constructor() {
    }

    public start(flowStateController: FlowStateController) {
        const tl: gsap.core.Timeline = gsap.timeline();
        TheCrypt.reelFrame.reset();
        TheCrypt.reelFrame.stopIdle();
        tl.add([
            () => {
                TheCrypt.reelBackground.onSpin();
                TheCrypt.reelFrame.onSymbolsDropOut();
            },
            TheCrypt.realArea.dropOut()
        ]);
        tl.add(() => {
            flowStateController.finish()
        }, "-0.5");
    }
}